// extracted by mini-css-extract-plugin
export default {"root":"JoinToCall_root__K4Mx-","you":"JoinToCall_you__DryKx"};